<template>
  <div class="rating rating-sm mt-1">
    <i
      v-for="index of 5"
      :key="index"
      :class="{ active: index <= star }"
      class="las la-star"
    />
  </div>
</template>
<script>
export default {
  props: { star: Number },
};
</script>
